import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProductsComponent } from './products/products.component';
import { BoAccountSelectedGuard } from '@mkp/core/feature-guard';

export const routes: Routes = [
  {
    path: '',
    component: ProductsComponent,
    canActivate: [BoAccountSelectedGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProductsRoutingModule {}
